import script from "./valueOverview.vue?vue&type=script&lang=ts&setup=true"
export * from "./valueOverview.vue?vue&type=script&lang=ts&setup=true"

import "./valueOverview.vue?vue&type=style&index=0&id=6c853408&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c853408"]])

export default __exports__